module.exports = __webpack_public_path__ + "img/InstagramSansCondensed-Regular.c287e97d.svg";